import App from "./App";
import { RootProvider } from "./context/root-context";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
// import { msalInstance } from "./helpers/msalConfig";
import { RemoteProvider } from "./context/remote-context";
import { useEffect, useState } from "react";
import type { NavigateFunction } from "react-router-dom";
import { contentqaMsalInstance } from "./helpers/msalConfigModule";
import { msalInstance } from "./helpers/msalConfig";

export type MsalProps = {
  msal?: PublicClientApplication;
  accessedFromHost?: boolean;
  navigation?: NavigateFunction | undefined;
  WorkGroupID?: string;
  WorkSessionID?: string;
  userId?: string;
  marketingInsightRequestId?: string;
  clientId?: string;
};
const RemoteApp = ({
  msal,
  accessedFromHost,
  navigation,
  WorkSessionID,
  WorkGroupID,
  userId,
  clientId,
}: MsalProps) => {

  const [isInitialized, setIsInitialized] = useState(false);
  
  useEffect(() => {
    if (!accessedFromHost) {
      const initialize = async () => {
        await contentqaMsalInstance.initialize();
        setIsInitialized(true);
      };
      initialize();
    } else {
      console.log("Using provided MSAL instance: Got it from host");
      setIsInitialized(true);
    }
  }, []);

  if (!isInitialized) {
    return null;
  }

  return (
    <RemoteProvider
      accessedFromHost={accessedFromHost}
      WorkSessionID={WorkSessionID}
      WorkGroupID={WorkGroupID}
      UserId={userId}
      ClientId={clientId}
      navigate={navigation}
    >
      <div className="content-qa" id="contentqa">
        <RootProvider>
          {accessedFromHost && msal ? (
            <MsalProvider instance={msal}>
              <App />
            </MsalProvider>
          ) : (
            <MsalProvider instance={msalInstance}>
              <App />
            </MsalProvider>
          )}
        </RootProvider>
      </div>
    </RemoteProvider>
  );
};

export default RemoteApp;
